import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 引入全局样式
import "./assets/style/main.scss";
import { createRouter } from "./router";
import store from "./store";
// 引入工具包
import {
  parseTime,
  handleTree,
  resetForm,
  uploadImgToOss,
  hasPermission,
} from "../src/filters/index";
// 申明oss资源地址
import { ossUrl ,apiPath} from "../app.config";
// 注册-拖拽组件
// import VueDND from 'awe-dnd';
// Vue.use(VueDND);
import appConfig from "../app.config";
// 全局方法挂载
Vue.prototype.handleTree = handleTree;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.uploadImgToOss = uploadImgToOss;
Vue.prototype.hasPermission = hasPermission;
Vue.use(ElementUI);
import md5 from "js-md5";
Vue.prototype.$md5 = md5;

import ant from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
Vue.use(ant);

import echarts from "echarts";
import axios from "axios";

Vue.config.productionTip = false;

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.ossUrl = ossUrl;
Vue.prototype.apiPath = apiPath;
Vue.prototype.store = store;

// 内容复制到剪贴板
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// 渐进式
import progressive from "progressive-image/dist/vue";
Vue.use(progressive, {
  removePreview: true,
  scale: true,
});
//节流 
const pointDoms = []; 
Vue.directive("points", {
  inserted(el, binding) {
    pointDoms.push(el); // 存储使用这个指令的DOM
    el.addEventListener('click', () => {
      // 禁用所有使用这个指令的DOM结构点击事
      pointDoms.forEach(pointItem => {
        pointItem.style.pointerEvents = 'none';
      });
      setTimeout(() => {
        // 启动所有使用这个指令的DOM结构点击事件
        pointDoms.forEach(pointItem => {
          pointItem.style.pointerEvents = 'auto';
        });
      }, binding.value || 1000);
    })
  }
});
// 导出一个工厂函数，用于创建新的
// 应用程序、router 和 store 实例
export function createApp() {
  const router = createRouter();
  const app = new Vue({
    router,
    store,
    // 根实例简单的渲染应用程序组件。
    render: (h) => h(App),
  });
  return { app, router, store };
}
